import classNames from "classnames";
import React from "react";
import { ContactDataResponse } from "../../../integrations/allkort/graphql/interface/Customer";
import { ComputerCloudIcon } from "../../svgs/ExpressonSVGs";

type CardEInvoiceDeliveryProps = {
    isActiveMethod: boolean
    customerContactData: ContactDataResponse
    isCompany: boolean
    onSelect?: () => void
}

const CardEInvoiceDelivery: React.FC<CardEInvoiceDeliveryProps> = ({ isActiveMethod, customerContactData, isCompany, onSelect }) => {
    const [clicked, setClicked] = React.useState(false);

    const handleClick = () => {
        if (!isActiveMethod && onSelect) {
            onSelect();
            return;
        }
        setClicked(true);
        setTimeout(() => {
            setClicked(false);
        }, 3000);
    };

    return (
        <div
            className={classNames(
                "method",
                'einvoice-delivery-method-component',
                { "active": isActiveMethod }
            )}
            onClick={handleClick}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleClick(); } }}
            tabIndex={0}
        >
            <div className="method-header">
                <span
                    className={classNames(
                        "method-icon",
                        { 'clicked': clicked }
                    )}
                >{/* Empty: CSS will fill in the visuals. */}</span>

                <div className="method-content">
                    <span className="method-name">Via e-faktura</span>
                    <p>
                        {isCompany ? (
                            isActiveMethod
                                ? 'Fakturan skickas till din bank som e-faktura.'
                                : 'Anslut e-faktura genom peppol-nätverket eller VAN.'
                        ) : (
                            isActiveMethod
                                ? 'Fakturan skickas till din bank som e-faktura.'
                                : 'Klicka för att läsa mer om hur du ansluter e-faktura.'
                        )
                        }
                    </p>
                </div>

                <ComputerCloudIcon width={45} height={45} />
            </div>
        </div>
    );
};

export default CardEInvoiceDelivery;
